'use client';
import { BoxProps } from '@chakra-ui/react';
import { useContext } from 'react';

import { LoggedIn } from '~/components/common/LoggedIn';
import { RootContext } from '~/store';
import { ErrorMessage } from '~/types/error';
import { GlobalLayout } from './GlobalLayout';

type Props = {
  hidden_header?: boolean;
  hidden_footer?: boolean;
  children?: React.ReactNode;
  error?: ErrorMessage;
  is_show_error?: boolean;
  closeError?: () => void;
  page_title?: string;
  float_bg_color?: string;
  title?: string;
  keywords?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  maxW?: BoxProps['maxW'];
};

export const LoggedInLayout: React.FC<Props> = (props: Props) => {
  const { user, loggedInState } = useContext(RootContext);

  return (
    <GlobalLayout
      page_title={props.page_title}
      float_bg_color={props.float_bg_color}
      hidden_header={props.hidden_header}
      hidden_footer={props.hidden_footer}
      max_width={props.maxW}
    >
      <LoggedIn user={user ?? undefined} loading={loggedInState === 'loading'}>
        {props.children}
      </LoggedIn>
    </GlobalLayout>
  );
};
